import type { ReactNode } from "react";

import { footerCss } from "~/client/components/search/IncrementalSearchResult/ListFooter/index.styles";

interface Props {
  children: ReactNode;
}
export const ListFooter: React.FC<Props> = ({ children }) => {
  return <div css={footerCss}>{children}</div>;
};
